import { render, staticRenderFns } from "./logsReport.vue?vue&type=template&id=55591ed1"
import script from "./logsReport.vue?vue&type=script&lang=js"
export * from "./logsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports